export default __webpack_public_path__ + "static/media/hs_pushup.bf067811.svg";